import { useSelector } from 'react-redux';
import { selectPermissions, selectUser } from '../store/slices/authSlice';

export function usePermission() {
  const permissions = useSelector(selectPermissions);
  const user = useSelector(selectUser);
  const isAdmin = user?.role?.isSystem === true || user?.role?.code === 'admin' || user?.role?.code === 'super_admin';

  const hasPermission = (permissionCode) => {
    if (isAdmin) return true;
    return permissions.includes(permissionCode);
  };

  const hasAnyPermission = (...codes) => {
    if (isAdmin) return true;
    return codes.some((code) => permissions.includes(code));
  };

  const hasAllPermissions = (...codes) => {
    if (isAdmin) return true;
    return codes.every((code) => permissions.includes(code));
  };

  const hasModuleAccess = (moduleName) => {
    if (isAdmin) return true;
    return permissions.some((p) => p.startsWith(moduleName + '.'));
  };

  return { hasPermission, hasAnyPermission, hasAllPermissions, hasModuleAccess, isAdmin, permissions };
}
